import type { ReactNode } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box } from "@mui/joy";
import DarkTypography from "../../common/DarkTypography";
import { statsSectionAccordionSx } from "../../../styles/globalStyles";
import { KeyboardArrowDownIcon } from "../../../styles/StyledMUI";

type StatsSectionProps = {
  title: string;
  children: ReactNode;
};

export default function StatsSection({ title, children }: StatsSectionProps) {
  return (
    <Accordion defaultExpanded sx={statsSectionAccordionSx}>
      <AccordionSummary indicator={<KeyboardArrowDownIcon />}>
        <DarkTypography level="title-lg" colorVariant="title" component="h2">
          {title}
        </DarkTypography>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "minmax(0, 1fr)", lg: "repeat(2, minmax(0, 1fr))" },
            gap: { xs: 1.5, md: 2 },
          }}
        >
          {children}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
